<div class="container">
  @if (size === 'medium') {
    <i nz-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="40" viewBox="0 0 64 40" fill="none">
        <path
          d="M32 40.0001C49.6731 40.0001 64 36.9425 64 33.1708C64 29.3991 49.6731 26.3416 32 26.3416C14.3269 26.3416 0 29.3991 0 33.1708C0 36.9425 14.3269 40.0001 32 40.0001Z"
          fill="#F5F5F5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M55 13.4244L44.854 2.2029C44.367 1.43803 43.656 0.975586 42.907 0.975586H21.093C20.344 0.975586 19.633 1.43802 19.146 2.20193L9 13.4253V22.439H55V13.4244Z"
          stroke="#D9D9D9"
          stroke-width="0.487805"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.613 16.518C41.613 14.9521 42.607 13.6594 43.84 13.6584H55V31.3531C55 33.4243 53.68 35.1219 52.05 35.1219H11.95C10.32 35.1219 9 33.4233 9 31.3531V13.6584H20.16C21.393 13.6584 22.387 14.9492 22.387 16.515V16.5365C22.387 18.1023 23.392 19.3667 24.624 19.3667H39.376C40.608 19.3667 41.613 18.0906 41.613 16.5248V16.518Z"
          fill="#FAFAFA"
          stroke="#D9D9D9"
          stroke-width="0.487805"
        />
      </svg>
    </i>
  }
  @if (size === 'large') {
    <i nz-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="184" height="114" viewBox="0 0 184 114" fill="none">
        <path
          d="M25.875 80C9.85688 83.5947 0 88.4916 0 93.8884C0 104.921 41.1898 113.864 92 113.864C142.81 113.864 184 104.921 184 93.8884C184 88.4916 174.143 83.5947 158.125 80V88.708C158.125 94.7664 154.33 99.7317 149.644 99.7317H34.3563C29.67 99.7317 25.875 94.7635 25.875 88.708V80Z"
          fill="black"
          fill-opacity="0.06"
        />
        <path
          d="M119.637 45.3152C119.637 40.7351 122.495 36.954 126.04 36.9512H158.125V88.708C158.125 94.7663 154.33 99.7317 149.644 99.7317H34.3562C29.67 99.7317 25.875 94.7634 25.875 88.708V36.9512H57.96C61.5049 36.9512 64.3626 40.7266 64.3626 45.3067V45.3695C64.3626 49.9496 67.252 53.6479 70.794 53.6479H113.206C116.748 53.6479 119.637 49.9153 119.637 45.3352V45.3152Z"
          fill="black"
          fill-opacity="0.04"
          stroke="black"
          stroke-opacity="0.15"
        />
        <path
          d="M158.125 37.2662L128.955 4.44342C127.555 2.20615 125.511 0.853516 123.358 0.853516H60.6424C58.489 0.853516 56.4449 2.20615 55.0448 4.44056L25.875 37.2691"
          stroke="black"
          stroke-opacity="0.15"
        />
      </svg>
    </i>
  }
  <span class="paragraph-medium regular">
    {{ message ? message : ('korviuNoData.noData' | translate) }}
  </span>
</div>
